import { GroutingData } from "../types/GroutingData";
import { StagingTitelineAppGrouting } from "../types/StagingTitelineAppGrouting";
import { getApiUrl } from '../config/api';

export const fetchGroutingByPid = async (pid?: number, aid: number = -1): Promise<GroutingData[]> => {
    const validPid = pid ?? -1;
    const apiUrl = getApiUrl(`/api/TitelineGrouting/GetGroutingByPid/${validPid}`);

    try {
        const response = await fetch(apiUrl, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            },
        });

        if (!response.ok) {
            if (response.status === 404) {
                console.warn(`No groutings found for Pid: ${validPid} (404 Not Found)`);
            } else {
                console.error(`Error fetching groutings for Pid: ${validPid} - ${response.status} ${response.statusText}`);
            }
            return [];
        }

        let backendData: StagingTitelineAppGrouting[] = await response.json();
        if (pid === -1) {
            backendData = backendData.filter((grouting) => grouting.DataSource === aid.toString());
        }

        return backendData.map((grouting) => ({
            key: grouting.Gid,
            gid: grouting.Gid,
            pid: grouting.Pid,
            hole_id: grouting.HoleID,
            drill_site: grouting.DrillSite,
            bags_used: grouting.BagsUsed,
            metres: grouting.Metres,
            volume: grouting.Volume,
        }));

    } catch (error) {
        console.error("Error in fetchGroutingByPid API call:", error);
        return [];
    }
};

export const addGroutingRow = async (groutingRow: GroutingData, aid: number = -1) => {
    const apiUrl = getApiUrl('/api/TitelineGrouting/AddGrouting');

    const cloudPayload = [
        {
            Pid: groutingRow.pid,
            HoleID: groutingRow.hole_id,
            DrillSite: groutingRow.drill_site,
            BagsUsed: groutingRow.bags_used,
            Metres: groutingRow.metres,
            Volume: groutingRow.volume,
            DataSource: aid,
        },
    ];

    try {
        const response = await fetch(apiUrl, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(cloudPayload),
        });

        if (response.ok) {
            console.log("Grouting row added to cloud successfully.");
            return true;
        } else {
            console.error(
                "Failed to add grouting row to cloud:",
                response.status,
                response.statusText
            );
            return false;
        }
    } catch (error) {
        console.error("Error in addGroutingRow API call:", error);
        return false;
    }
};

export const updateGroutingRow = async (gid: number, updatedRow: GroutingData) => {
    const apiUrl = getApiUrl(`/api/TitelineGrouting/UpdateGroutingByGid/${gid}`);

    const cloudPayload = {
        HoleID: updatedRow.hole_id,
        DrillSite: updatedRow.drill_site,
        BagsUsed: updatedRow.bags_used,
        Metres: updatedRow.metres,
        Volume: updatedRow.volume,
    };

    console.log(`cloudPayload`, cloudPayload);

    try {
        const response = await fetch(apiUrl, {
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(cloudPayload),
        });

        if (response.ok) {
            console.log(`Grouting row with Gid ${gid} updated successfully.`);
            return true;
        } else {
            console.error(
                `Failed to update grouting row with Gid ${gid}:`,
                response.status,
                response.statusText
            );
            return false;
        }
    } catch (error) {
        console.error("Error in updateGroutingRow API call:", error);
        return false;
    }
};

export const deleteGroutingByGid = async (gid: number) => {
    const apiUrl = getApiUrl(`/api/TitelineGrouting/DeleteGroutingByGid/${gid}`);

    try {
        const response = await fetch(apiUrl, {
            method: "DELETE",
        });

        if (response.ok) {
            const responseData = await response.json();
            console.log("DeleteGroutingByGid API response:", responseData);
            return true;
        } else {
            console.error("Failed to delete grouting row from the cloud:", response.status, response.statusText);
            return false;
        }
    } catch (error) {
        console.error("Error in deleteGroutingByGid API call:", error);
        return false;
    }
};